import React, { FC } from 'react';

import { useNativeTabBarContentInset } from 'hooks/use-native-tab-bar-content-inset';
import { useAuthContext } from 'state/auth';
import { spacing } from 'styles/constants';

import { EmptyStateContent } from './empty-state-content';
import { ButtonCard, ButtonWrapper, StyledActionButton } from './styled';
import { IEmptyStateProps } from './types';

export const EmptyState: FC<React.PropsWithChildren<IEmptyStateProps>> = ({ content }) => {
  const { buttonAction } = content;
  const { isAuthenticated } = useAuthContext();
  const shouldRenderSignUpButton = Boolean(!isAuthenticated && buttonAction?.actionText);
  const nativeTabBarContentInset = useNativeTabBarContentInset();
  // Add breathing room above the floating tab bar instead of butting the CTA right against it.
  const bottomInset = nativeTabBarContentInset ? nativeTabBarContentInset + spacing.$4 : 0;

  return (
    <>
      <EmptyStateContent
        content={content}
        shouldRenderSignUpButton={shouldRenderSignUpButton}
        bottomInset={bottomInset}
      />
      {/* paddingBottom is a measured runtime pixel value, so it's set via native `style`
      rather than a styled-system prop — see the comment on ButtonWrapper in styled.ts. */}
      {shouldRenderSignUpButton && (
        <ButtonWrapper style={{ paddingBottom: bottomInset }}>
          <ButtonCard bottomInset={bottomInset}>
            <StyledActionButton to={buttonAction?.actionUrl?.locale || ''} fullWidth>
              {buttonAction?.actionText?.locale}
            </StyledActionButton>
          </ButtonCard>
        </ButtonWrapper>
      )}
    </>
  );
};
